import { videoUrl } from '@helpers/cloudinary';
import { imageUrl } from '@helpers/image';
import * as React from 'react';
import S from './PinPreview.styles';
const PinPreview = (props) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.ImageWrapper, null, props.item.image ? (React.createElement(S.Image, { loading: "lazy", role: "presentation", src: imageUrl(props.item.image, { width: 306 }) })) : (props.item.videoId && (React.createElement(S.Image, { loading: "lazy", role: "presentation", src: videoUrl(props.item.videoId, { format: 'jpg' }) })))),
        React.createElement(S.Overlay, null,
            React.createElement(S.Title, null, props.item.title))));
};
export default PinPreview;
